import { useState } from 'react';
import { X } from 'lucide-react';

const BRANCHES = [
  { id: 'C30', label: 'C30 — Encon Insulation' },
  { id: 'E70', label: 'E70 — Encon Solutions' },
];

export default function CreateListModal({ isOpen, onClose, onSave, initial }) {
  const [name, setName] = useState(initial?.name || '');
  const [branches, setBranches] = useState(initial?.branches || ['C30']);
  const [saving, setSaving] = useState(false);

  if (!isOpen) return null;

  const toggleBranch = (id) => {
    setBranches(prev =>
      prev.includes(id) ? prev.filter(b => b !== id) : [...prev, id]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    if (branches.length === 0) { alert('Select at least one branch'); return; }
    setSaving(true);
    try {
      await onSave(name.trim(), branches);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6">
        <div className="flex items-center justify-between mb-5">
          <h2 className="text-lg font-bold text-gray-900">{initial ? 'Edit Tracking List' : 'New Tracking List'}</h2>
          <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-gray-100 transition-colors">
            <X className="w-4 h-4 text-gray-500" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">List Name *</label>
            <input
              type="text"
              value={name}
              onChange={e => setName(e.target.value)}
              placeholder="e.g. Q2 Active Projects"
              className="w-full px-3 py-2.5 rounded-xl border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              autoFocus
              data-testid="pt-list-name-input"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Branch Visibility *</label>
            <div className="space-y-2">
              {BRANCHES.map(b => (
                <label key={b.id} className="flex items-center gap-3 cursor-pointer group">
                  <input
                    type="checkbox"
                    checked={branches.includes(b.id)}
                    onChange={() => toggleBranch(b.id)}
                    className="w-4 h-4 rounded accent-blue-600"
                    data-testid={`pt-branch-${b.id.toLowerCase()}`}
                  />
                  <span className="text-sm text-gray-700 group-hover:text-gray-900">
                    <span className="font-semibold">{b.id}</span> — {b.label.split('— ')[1]}
                  </span>
                </label>
              ))}
            </div>
          </div>

          <div className="flex gap-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2.5 rounded-xl border border-gray-200 text-sm font-semibold text-gray-700 hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={saving || !name.trim() || branches.length === 0}
              className="flex-1 px-4 py-2.5 rounded-xl text-white text-sm font-semibold disabled:opacity-50 transition-opacity"
              style={{ backgroundColor: '#ee7203' }}
              data-testid="pt-save-list-btn"
            >
              {saving ? 'Saving…' : initial ? 'Save Changes' : 'Create List'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
